export const customerConstants = {
  GET_CUSTOMERS_REQUEST: "GET_CUSTOMERS_REQUEST",
  GET_CUSTOMERS_SUCCESS: "GET_CUSTOMERS_SUCCESS",
  GET_CUSTOMERS_FAILURE: "GET_CUSTOMERS_FAILURE",

  ADD_CUSTOMERS_FILTER: "ADD_CUSTOMERS_FILTER",

  GET_CUSTOMER_REQUEST: "GET_CUSTOMER_REQUEST",
  GET_CUSTOMER_SUCCESS: "GET_CUSTOMER_SUCCESS",
  GET_CUSTOMER_FAILURE: "GET_CUSTOMER_FAILURE",

  GET_EXCEL_CUSTOMERS_REQUEST: "GET_EXCEL_CUSTOMERS_REQUEST",
  GET_EXCEL_CUSTOMERS_SUCCESS: "GET_EXCEL_CUSTOMERS_SUCCESS",
  GET_EXCEL_CUSTOMERS_FAILURE: "GET_EXCEL_CUSTOMERS_FAILURE",

  ADD_CUSTOMER_INFO_REQUEST: "ADD_CUSTOMER_INFO_REQUEST",
  ADD_CUSTOMER_INFO_SUCCESS: "ADD_CUSTOMER_INFO_SUCCESS",
  ADD_CUSTOMER_INFO_FAILURE: "ADD_CUSTOMER_INFO_FAILURE",

  UPLOAD_EXCEL_CUSTOMERS_REQUEST: "UPLOAD_EXCEL_CUSTOMERS_REQUEST",
  UPLOAD_EXCEL_CUSTOMERS_SUCCESS: "UPLOAD_EXCEL_CUSTOMERS_SUCCESS",
  UPLOAD_EXCEL_CUSTOMERS_FAILURE: "UPLOAD_EXCEL_CUSTOMERS_FAILURE",

  CREATE_SUPPLIER_BASE_ON_CUSTOMER_REQUEST:
    "CREATE_SUPPLIER_BASE_ON_CUSTOMER_REQUEST",
  CREATE_SUPPLIER_BASE_ON_CUSTOMER_SUCCESS:
    "CREATE_SUPPLIER_BASE_ON_CUSTOMER_SUCCESS",
  CREATE_SUPPLIER_BASE_ON_CUSTOMER_FAILURE:
    "CREATE_SUPPLIER_BASE_ON_CUSTOMER_FAILURE",

  ADD_CUSTOMER_REQUEST: "ADD_CUSTOMER_REQUEST",
  ADD_CUSTOMER_SUCCESS: "ADD_CUSTOMER_SUCCESS",
  ADD_CUSTOMER_FAILURE: "ADD_CUSTOMER_FAILURE",

  EDIT_CUSTOMER_REQUEST: "EDIT_CUSTOMER_REQUEST",
  EDIT_CUSTOMER_SUCCESS: "EDIT_CUSTOMER_SUCCESS",
  EDIT_CUSTOMER_FAILURE: "EDIT_CUSTOMER_FAILURE",

  GET_RELATION_CUSTOMER_REQUEST: "GET_RELATION_CUSTOMER_REQUEST",
  GET_RELATION_CUSTOMER_SUCCESS: "GET_RELATION_CUSTOMER_SUCCESS",
  GET_RELATION_CUSTOMER_FAILURE: "GET_RELATION_CUSTOMER_FAILURE",

  ADD_CUSTOMER_NOTE_REQUEST: "ADD_CUSTOMER_NOTE_REQUEST",
  ADD_CUSTOMER_NOTE_SUCCESS: "ADD_CUSTOMER_NOTE_SUCCESS",
  ADD_CUSTOMER_NOTE_FAILURE: "ADD_CUSTOMER_NOTE_FAILURE",

  GET_CUSTOMER_NOTES_REQUEST: "GET_CUSTOMER_NOTES_REQUEST",
  GET_CUSTOMER_NOTES_SUCCESS: "GET_CUSTOMER_NOTES_SUCCESS",
  GET_CUSTOMER_NOTES_FAILURE: "GET_CUSTOMER_NOTES_FAILURE",

  GET_CUSTOMER_RELATION_TO_USER_REQUEST: "GET_CUSTOMER_RELATION_TO_USER_REQUEST",
  GET_CUSTOMER_RELATION_TO_USER_SUCCESS: "GET_CUSTOMER_RELATION_TO_USER_SUCCESS",
  GET_CUSTOMER_RELATION_TO_USER_FAILURE: "GET_CUSTOMER_RELATION_TO_USER_FAILURE",
};
